import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RecaptchaV2 from 'react-grecaptcha';
import { loadCaptchaSelector } from '../ducks/selectors.js';
import { grecaptchaCallback } from '../ducks/index.js';

const ReCaptcha = () => {
	const dispatch = useDispatch();
	const [isCaptchaLoaded, setCaptchaLoaded] = useState(false);
	const loadCaptcha = useSelector(loadCaptchaSelector);

	const captchaCallback = response => {
		return dispatch(grecaptchaCallback(response));
	};
	useEffect(() => {
		if (!loadCaptcha || isCaptchaLoaded) {
			return;
		}
		setCaptchaLoaded(true);
	}, [loadCaptcha, isCaptchaLoaded]);

	if (!loadCaptcha && !isCaptchaLoaded) {
		return null;
	}

	return (
		<RecaptchaV2
			sitekey="6LfW3CEUAAAAAAANBgnrxLj_YebjlvwVImDy0FU3"
			callback={captchaCallback}
			expiredCallback={() => {}}
			className="g-recaptcha"
			invisible
			badge="inline"
		/>
	);
};

export default ReCaptcha;
